import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ResultImpressionCard from '../../components/result/ResultImpressionCard';
import AttractionInsightCard from '../../components/result/AttractionInsightCard';
import ResultCTACompare from '../../components/result/ResultCTACompare';

export default function ResultPage() {
  const { analysisId } = useParams();
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'radial-gradient(circle at top, #1e1b4b 0%, #0f172a 40%, #020617 100%)',
      color: '#f8fafc',
      padding: '4rem 1.5rem',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '2.5rem'
      }}>
        {/* Navigation/Header Area */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <button 
            onClick={() => navigate('/')} 
            style={{ background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 0 }}
          >
            ← Back to Home
          </button>
          <div style={{ fontSize: '0.8rem', color: '#64748b' }}>
            ID: {analysisId || 'MOCK_1234'}
          </div>
        </div>

        {/* Result Hero Section */}
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: '900', margin: 0, background: 'linear-gradient(90deg, #f8fafc, #cbd5e1)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Your First Impression Result
          </h1>
          <p style={{ fontSize: '1.1rem', color: '#94a3b8', margin: 0, lineHeight: '1.5' }}>
            Here's how your facial features may be perceived by others.
          </p>
          
          {/* Mock Face Thumbnail Placeholder */}
          <div style={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(99,102,241,0.2), rgba(236,72,153,0.2))',
            margin: '1.5rem auto 0',
            border: '2px solid rgba(255,255,255,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 10px 25px rgba(0,0,0,0.5)'
          }}>
            <span style={{ fontSize: '2rem' }}>👤</span>
          </div>
        </div>

        {/* Main Impression Summary Card */}
        <div style={{ animation: 'fadeUp 0.6s ease-out forwards', opacity: 0, transform: 'translateY(20px)' }}>
          <ResultImpressionCard />
        </div>

        {/* Primary Action (Moved up to be above the fold) */}
        <div style={{ animation: 'fadeUp 0.8s ease-out forwards', opacity: 0, transform: 'translateY(20px)' }}>
          <ResultCTACompare />
        </div>

        {/* Attraction Insight Section */}
        <div style={{ animation: 'fadeUp 1s ease-out forwards', opacity: 0, transform: 'translateY(20px)' }}>
          <AttractionInsightCard />
        </div>
        
        {/* Teasers Section */}
        <div style={{ 
          marginTop: '2rem', 
          borderTop: '1px solid rgba(255,255,255,0.05)', 
          paddingTop: '2.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
          animation: 'fadeUp 1.2s ease-out forwards', 
          opacity: 0, 
          transform: 'translateY(20px)' 
        }}>
          {/* Chemistry / Personality Teaser Outline */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{ margin: '0 0 0.5rem 0', color: '#e2e8f0', fontSize: '1.1rem' }}>Face chemistry is only the first layer.</h4>
            <p style={{ margin: '0 0 1rem 0', color: '#94a3b8', fontSize: '0.9rem' }}>Add personality compatibility to explore deeper relationship dynamics.</p>
            <button style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#cbd5e1',
              padding: '0.75rem 1.5rem',
              borderRadius: '999px',
              fontSize: '0.9rem',
              cursor: 'pointer'
            }}>
              Start Personality Compatibility
            </button>
          </div>
        </div>
      </div>
      
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes fadeUp {
          to { opacity: 1; transform: translateY(0); }
        }
      `}} />
    </div>
  );
}
